import { useContext } from 'react';

import OrganizationTypeData from './OrganizationTypeData';
import { OrganizationTypeStateContext } from './OrganizationTypeContextProvider';

const useOrganizationTypeData = () => {
  const [organizationTypeState, setOrganizationTypeState] = useContext(OrganizationTypeStateContext);

  const getOrganizationTypes = () => {
    return OrganizationTypeData.getOrganizationTypeData(organizationTypeState, setOrganizationTypeState);
  };

  return {
    organizationTypeState,
    setOrganizationTypeState,
    getOrganizationTypes,
  };
};

export default useOrganizationTypeData;